import { create } from "zustand"

export type IConfirmationType = "delete"

interface IConfirmationData {
  title?: string
  type: IConfirmationType
  buttonLoading?: boolean
  confirmationButtonText?: string
  message: string
  callback: VoidFunction
}

interface IConfirmationState {
  show: IConfirmationData | undefined
  showConfirmation: (data: IConfirmationData) => void
  closeModal: () => void
  onConfirm: () => void
}

export const useConfirmationStore = create<IConfirmationState>((set, get) => ({
  show: undefined,
  showConfirmation: data => set({ show: data }),
  closeModal: () => set({ show: undefined }),
  onConfirm: () => {
    const { show } = get()
    // set({ show: undefined })
    if (show) {
      set({
        show: { ...show, buttonLoading: true }
      })
    }
    show?.callback()
  }
}))
